import { Swiper } from 'swiper';
import { Navigation, Pagination, Scrollbar, Autoplay, EffectFade } from 'swiper/modules';

export default function initSwiper() {
	initBasicSwiper();
	initCustomSwiper();
}

function initBasicSwiper() {
	// Initialize basic swiper instances with [data-swiper] attribute
	const swiperElements = document.querySelectorAll('[data-swiper]');

	swiperElements.forEach((element) => {
		const config = element.dataset.swiperConfig ? JSON.parse(element.dataset.swiperConfig) : {};

		const defaultConfig = {
			modules: [Navigation, Pagination, Scrollbar, Autoplay],
			slidesPerView: 1,
			spaceBetween: 30,
			loop: true,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
		};

		new Swiper(element, { ...defaultConfig, ...config });
	});
}

function initCustomSwiper() {
	// Initialize any custom swiper instances
	// Add custom swiper configurations here as needed

	// Example: Hero slider
	const heroSlider = document.querySelector('.hero-swiper');
	if (heroSlider) {
		new Swiper(heroSlider, {
			modules: [Pagination, Autoplay, EffectFade],
			slidesPerView: 1,
			spaceBetween: 0,
			loop: true,
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			},
			autoplay: {
				delay: 6000,
				disableOnInteraction: false,
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
		});
	}
}
